import { Component, OnInit } from "@angular/core";
import { DataService} from "src/app/services/data.service";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http"
import { map } from "rxjs/operators";

@Component({
  selector: "app-category",
  templateUrl: "./category.page.html",
  styleUrls: ["./category.page.scss"],
})
export class CategoryPage implements OnInit {
  galleryType = 'regular';
  res : Observable<any>;
  searchTerm = "";
  data = [];
  item: any;
  results;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit() {
   

    
  }

  ionViewWillEnter() {
    const itemId = +this.route.snapshot.paramMap.get("id");
    this.item = this.dataService.getProductSearchResult(this.searchTerm)
  }
  searchChanged() {
    this.results = this.dataService.getProductSearchResult(this.searchTerm)
    
  }

  addToCart(cart){
    this.results = this.dataService.addProduct(cart);
  }
}
